const updateContentDimensions = () => {
  const body = document.querySelector('body');
  const element = document.querySelector('.main-container');
  const height = window.innerHeight;

  if (element) {
    element.style.minHeight = `${height - 100}px`;
  }

  body.style.overflowY = 'auto';
};

export { updateContentDimensions };
